import { CRTMSG, DELMSG, UPTMSG } from 'src/Helper/toastmsg';
import {
    UOM_CREATE, UOM_LIST, UOM_SINGLE, UOM_UPDATE, UOM_DELETE, CLEAR_UOM_TEMP_STATES, CLEAR_UOM_STATES
} from '../../../Helper/actionsTypes';

const UOMReducer = (state = [], action) => {
     switch (action.type) {
        case UOM_LIST: {
            return action.payload.code === 200
                ? { ...state, list: action.payload.results }
                : { ...state, list: [] };
        }
        case UOM_SINGLE: {
            if (action.payload.code === 200) return { ...state, single: action.payload.results[0] }
            else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else return { ...state, single: {} };
        }
        case UOM_DELETE: {
            if (action.payload.code === 500) return { ...state, itemDeleted: false, message: DELMSG }
           else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else if (action.payload.code === 200) return { ...state, itemDeleted: true, message: action.payload.message }
            else return { ...state, itemDeleted: false, message: action.payload.message }
        }
        case UOM_CREATE: {
            if (action.payload.code === 500) return { ...state, itemSaved: false, message: CRTMSG }
            if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else if (action.payload.code === 200) return { ...state, itemSaved: true, message: action.payload.message }
            else return { ...state, itemSaved: false, message: action.payload.message }
        }
        case UOM_UPDATE: {
            if (action.payload.code === 500) return { ...state, itemUpdated: false, message: UPTMSG }
            else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else if (action.payload.code === 200) return { ...state, itemUpdated: true, message: action.payload.message }
            else return { ...state, itemUpdated: false, message: action.payload.message }
        }
        case CLEAR_UOM_TEMP_STATES: return { ...state, itemDeleted: null, itemSaved: null, itemUpdated: null, message: null, badReq: null, create: {}, update: {} };
        case CLEAR_UOM_STATES: return {};
        default: return state;
    }
};

export default UOMReducer;